import { IUserAction, IUser, USER_ACTIONS } from './model.d'

export const userReducer = (state: IUser, action: IUserAction): IUser => {
    switch (action.type) {
        case USER_ACTIONS.SET_TOKEN_AUTH_DATA:
            return {
                ...state,
                token: action.payload.token,
                isAuthenticated: true
            }
        case USER_ACTIONS.CLEAR_USER_AUTH_DATA:
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                userProfile: null
            }
        case USER_ACTIONS.SET_USER_ADMIN_PROFILE:
            return {
                ...state,
                userProfile: action.payload.userProfile
            }
        default:
            return state
    }
}